import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { PorangeButton } from "@/components/atoms/PorangeButton";

export const Statement = ({ onAnswer }) => {
    const [showTitle, setShowTitle] = useState(false);
    const [showSubtitle, setShowSubtitle] = useState(false);
    const [showLevels, setShowLevels] = useState(false);
    const [showButton, setShowButton] = useState(false);
    const [isExiting, setIsExiting] = useState(false);
    const [activePin, setActivePin] = useState(0);

    const pins = [
        { color: '#22C55E', label: '100% Gluten-Free', emoji: '✨', description: 'Dedicated gluten-free facility' },
        { color: '#3B82F6', label: 'Celiac Friendly', emoji: '🛡️', description: 'Strict protocols & trained staff' },
        { color: '#F59E0B', label: 'Accommodating', emoji: '⚡', description: 'Good practices but shared kitchen' },
        { color: '#EF4444', label: 'GF Options', emoji: '⭐', description: 'Basic gluten-free options available' }
    ];

    useEffect(() => {
        setTimeout(() => setShowTitle(true), 100);
        setTimeout(() => setShowSubtitle(true), 400);
        setTimeout(() => setShowLevels(true), 1000);
        setTimeout(() => setShowButton(true), 1600);

        const interval = setTimeout(() => {
            setInterval(() => {
                setActivePin(current => (current + 1) % pins.length);
            }, 2000);
        }, 1000);

        return () => {
            clearInterval(interval);
            clearTimeout(interval);
        };
    }, []);

    const handleContinue = () => {
        setShowButton(false);
        setTimeout(() => {
            setIsExiting(true);
            setTimeout(() => onAnswer('continue'), 800);
        }, 400);
    };

    return (
        <div
            className={classNames(
                "relative h-full flex flex-col items-center justify-start px-6",
                isExiting
                    ? "opacity-0"
                    : "opacity-100",
                "transition-opacity duration-500"
            )}
        >
            <div className="text-center space-y-2 max-w-[600px] mt-4 mb-8">
                <div className="overflow-hidden">
                    <h1
                        className={classNames(
                            "text-[32px] md:text-[40px] leading-tight font-bold text-black transition-all duration-500",
                            showTitle ? "opacity-100" : "opacity-0"
                        )}
                    >
                        Atly gives each place a{' '}
                        <span className="bg-clip-text text-transparent bg-gradient-to-r from-pink-500 via-orange-500 to-pink-500">
                            safety level
                        </span>{' '}
                        for quick and easy discovery
                    </h1>
                </div>
            </div>

            <div
                className={classNames(
                    "w-full max-w-[400px] mx-auto",
                    "transition-all duration-500",
                    showLevels ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
                )}
            >
                <div className="space-y-2.5 w-full">
                    {pins.map((pin, index) => (
                        <div
                            key={index}
                            style={{
                                transitionDelay: showLevels ? `${index * 100}ms` : '0ms'
                            }}
                            className={classNames(
                                "flex flex-col p-2.5",
                                "rounded-xl transition-all duration-500",
                                "border-2",
                                !showLevels && "opacity-0 translate-y-4",
                                activePin === index
                                    ? "border-pink-500 bg-white shadow-lg scale-105"
                                    : "border-transparent bg-gray-50"
                            )}
                        >
                            <div className="flex items-center gap-3">
                                <div
                                    className="w-7 h-7 rounded-full flex items-center justify-center text-lg"
                                    style={{ backgroundColor: pin.color }}
                                >
                                    <span className="leading-none">{pin.emoji}</span>
                                </div>
                                <div className="flex flex-col gap-0.5">
                                    <span className="font-semibold text-gray-800 text-sm leading-tight">
                                        {pin.label}
                                    </span>
                                    <p className="text-gray-600 text-xs leading-tight">
                                        {pin.description}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <div
                className={classNames(
                    "fixed bottom-0 left-0 right-0 p-5 transition-all duration-500 bg-gradient-to-t from-white via-white to-transparent pb-6 pt-10",
                    showButton ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8 pointer-events-none"
                )}
            >
                <PorangeButton
                    full={true}
                    className="h-[56px] rounded-[16px] text-lg shadow-md"
                    onClick={handleContinue}
                >
                    Continue
                </PorangeButton>
            </div>
        </div>
    );
};

export default Statement; 